import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from '@miro-site/core';
import _theme from './theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TemplatesThemeProvider = function TemplatesThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: function theme(defaultTheme) {
      return _objectSpread(_objectSpread({}, defaultTheme), _theme);
    },
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), children]
  });
};

export default TemplatesThemeProvider;